import {remCalc} from '../../_utils'

export default {
    parts: ['container', 'list', 'listItem', 'listItemSx', 'heading'],
    baseStyle: {
        containerLinks: {
            color: 'text.inverse',
        },
        list: {
            display: 'flex',
            gap: 'medium.base',
            alignItems: 'flex-start',
            textStyle: ['body-medium'],
            opacity: 0.8,
        },
        headingLink: {
            textStyle: ['body-medium'],
        },
        heading: {
            textStyle: ['body-medium'],
            pb: remCalc(30),
            color: 'background.light-blue',
        },
        stackWrap: {
            flexWrap: 'wrap',
            justifyContent: 'center',
            width: '100%',
        },
    },
    variants: {
        vertical: {},
        horizontal: {
            listItem: {
                borderLeft: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                textStyle: ['body-xxsmall'],
                //paddingLeft: '0.5rem',
                paddingLeft: 'xsmall.base',
            },
            listItemSx: {
                '&:first-of-type': {
                    borderLeft: 0,
                    paddingLeft: 0,
                    marginLeft: 0,
                    paddingRight: 0,
                },
            },
            list: {
                gap: 'xsmall.base',
            },
        },
    },
    defaultProps: {
        variant: 'vertical',
    },
}
